import Box from "@mui/material/Box";
import styled from "@emotion/styled";

export const PatientChatsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const GroupChatListPanelHeaderWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
`;
